import { Link } from "react-router-dom";

import Seo from "../../components/Seo";
import { seoFromPublicPage } from "../../seo/publicPages";
import ArticleLayout from "./ArticleLayout";
import RelatedGuides from "./RelatedGuides";

export default function VanzareMasinaFoaieParcursPage() {
  return (
    <>
      <Seo {...seoFromPublicPage("/vanzare-masina-foaie-parcurs")} />
      <ArticleLayout
        eyebrow="Gestiune flotă"
        title="Ce se întâmplă cu foaia de parcurs când vinzi mașina sau o scoți din uz"
        lead="Luna în care mașina pleacă din firmă nu se închide pe 31. Foaia se oprește în ziua predării, iar kilometrii din contract trebuie să coincidă cu ultimul index. Un bon emis după acea dată nu mai ține de vehiculul vândut."
      >
        <p>
          Cât timp mașina circulă, foaia de parcurs ține evidența deplasărilor. În ziua în
          care o vinzi, o predai sau o scoți din uz, evidența se închide. Nu la sfârșitul
          lunii, nu «când apucă contabilul», ci la data la care firma nu mai are mașina.
        </p>
        <p>
          Inspectorul compară trei lucruri: data din contract sau din documentul de
          scoatere din uz, ultimul index de pe foaie și alimentările de după acea dată.
          Dacă cele trei nu se potrivesc, lunile anterioare — chiar bine ținute — intră
          și ele în discuție.
        </p>

        <h2>Ultima lună nu se lasă goală și nu se întinde până pe 31</h2>
        <p>
          Dacă mașina se vinde pe 12, foaia acoperă zilele de 1 până pe 12. Zilele de
          după predare nu se completează cu trasee, pentru că vehiculul nu mai era al
          firmei. O foaie dusă până pe 31, cu curse după vânzare, arată că evidența a
          fost făcută din urmă, nu în timp real.
        </p>
        <p>
          Același principiu se aplică la scoaterea din uz: accident, casare, mașină
          blocată în service fără perspectivă de revenire, sau decizia firmei de a nu o
          mai folosi. Data care contează este data de la care mașina nu mai circulă
          pentru firmă, nu data la care dispare din gestiune contabilă.
        </p>

        <h2>Kilometrii din contract trebuie să bată cu foaia</h2>
        <p>
          Contractul de vânzare-cumpărare, factura și procesul-verbal de predare-primire
          au un index. Foaia de parcurs are altul: kilometrii cumulați până în ultima zi
          de folosire. Cele două cifre trebuie să fie același lucru.
        </p>
        <p>
          Trei situații apar des:
        </p>
        <ul>
          <li>
            <strong>Indexul din contract e mai mare decât foaia.</strong> Au existat
            kilometri neînregistrați. La un regim de 100%, acei kilometri nu au
            justificare.
          </li>
          <li>
            <strong>Indexul din contract e mai mic decât foaia.</strong> Foaia declară
            drumuri pe care mașina nu le-a putut face. E mai greu de explicat decât
            lipsa unor kilometri.
          </li>
          <li>
            <strong>Nu există index în documentul de vânzare.</strong> Fără cifră,
            foaia rămâne neancorată. La control, lipsa ei se citește ca o evidență
            care nu poate fi verificată.
          </li>
        </ul>
        <p>
          Înainte de semnare, compară indexul din bord cu totalul de pe foaie. Diferența
          se rezolvă în ziua predării, nu peste șase luni, când nimeni nu mai știe cine
          a condus ultima cursă.
        </p>

        <h2>Alimentările de după predare nu mai sunt ale firmei</h2>
        <p>
          Un bon sau o factură cu dată ulterioară predării nu se leagă de mașina vândută.
          Carburantul cumpărat după ce vehiculul a plecat fie ține de altă mașină, fie
          nu este cheltuială a firmei. Data de pe documentul fiscal este cea care contează,
          nu data la care ajunge bonul la contabil.
        </p>
        <p>
          Rezervorul din ziua predării se închide odată cu foaia. Litrii rămași nu se
          «consumă» pe hârtie în zilele următoare, pe trasee care nu au mai avut loc.
          Legătura dintre alimentări, kilometri și rezervor este aceeași ca în restul
          anului; se oprește doar intervalul.
        </p>

        <h2>50% și 100% nu se recalculează pe lunile deja închise</h2>
        <p>
          Vânzarea nu schimbă regimul lunilor anterioare. Dacă până pe 12 mașina a fost
          folosită exclusiv economic și dosarul o susține, deducerea integrală rămâne
          pe acele zile. Dacă a fost folosită mixt, rămâne 50%. Faptul că vehiculul nu
          mai este în firmă pe 31 nu transformă retroactiv lunile trecute.
        </p>
        <p>
          În luna incompletă se aplică același regim, proporțional cu zilele în care
          mașina a fost a firmei. Nu se trece brusc la 100% «pentru că oricum pleacă»,
          și nu se renunță la documente pentru că luna e scurtă. Condițiile pentru
          deducerea integrală sunt în{" "}
          <Link to="/deducere-100-combustibil">articolul despre deducerea 100%</Link>.
        </p>

        <h2>Două mașini în aceeași lună</h2>
        <p>
          Când una iese pe 12 și alta intră pe 18, fiecare are propria foaie și propriul
          interval. Kilometrii nu se adună pe un singur document. Alimentările se
          repartizează pe vehiculul care exista în firmă în ziua bonului.
        </p>
        <div className="article-doc__table-wrap">
          <table className="article-doc__table">
            <thead>
              <tr>
                <th>Vehicul</th>
                <th>Interval pe foaie</th>
                <th>Ce nu intră</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Mașina vândută</td>
                <td>De la 1 până în ziua predării</td>
                <td>Curse și bonuri de după indexul din contract</td>
              </tr>
              <tr>
                <td>Mașina nouă</td>
                <td>Din ziua în care firma o preia</td>
                <td>Kilometri sau alimentări dinainte de preluare</td>
              </tr>
            </tbody>
          </table>
        </div>
        <p>
          Zilele dintre predare și preluare, dacă există, rămân fără vehicul. Nu se
          acoperă cu «deplasări» pe mașina care nu mai era, nici pe cea care nu intrase
          încă.
        </p>

        <h2>Scoaterea din uz fără vânzare</h2>
        <p>
          Nu orice oprire este o vânzare. Mașina poate rămâne în patrimoniu, dar să nu
          mai circule: accident, casare începută, decizie internă de a o ține în curte.
          Foaia se oprește în ultima zi de circulație efectivă. Cheltuielile de după
          acea zi — combustibil, mai ales — nu se justifică printr-o foaie care declară
          drumuri inexistente.
        </p>
        <p>
          Păstrează documentul care fixează data: proces-verbal intern, constatare de
          daună, sau decizia de scoatere din folosință. Fără o dată scrisă, «am oprit-o
          cândva în vară» nu închide evidența.
        </p>

        <h2>Greșeli frecvente</h2>

        <h3>Foaie până pe 31, deși predarea a fost pe 12</h3>
        <p>
          Traseele din a doua jumătate a lunii nu au vehicul. La compararea cu
          contractul, diferența de zile este vizibilă imediat.
        </p>

        <h3>Index mai mic în contract decât pe ultima foaie</h3>
        <p>
          Foaia susține mai mulți kilometri decât mașina avea la predare. Cifrele nu
          pot fi ambele adevărate.
        </p>

        <h3>Bonuri după data predării, trecute pe mașina vândută</h3>
        <p>
          Documentul fiscal este ulterior ieșirii din firmă. Cheltuiala nu are
          vehiculul pe care se sprijină.
        </p>

        <h3>O singură foaie pentru mașina veche și cea nouă</h3>
        <p>
          Două intervale, două indexuri, un singur tabel. Nu se poate vedea unde s-a
          oprit una și unde a început cealaltă.
        </p>

        <div className="article-doc__callout">
          <strong>În ziua predării</strong>
          <p>
            Notează indexul, închide foaia la acea dată și nu mai atașa alimentări
            ulterioare pe acel vehicul. Trei verificări, făcute o singură dată, țin
            locul unei reconstrucții de după control.
          </p>
        </div>

        <h2>Concluzie</h2>
        <p>
          Vânzarea sau scoaterea din uz închide foaia de parcurs la data predării, nu
          la capătul lunii. Indexul din contract și totalul de pe foaie trebuie să
          coincidă, iar bonurile de după acea dată nu mai aparțin mașinii care a
          plecat. Lunile deja închise își păstrează regimul. Mașina care o înlocuiește
          începe o foaie nouă, din ziua în care firma o preia.
        </p>
        <RelatedGuides currentPath="/vanzare-masina-foaie-parcurs" />
      </ArticleLayout>
    </>
  );
}
